import { useQuery } from "@tanstack/react-query";
import { LibraryAPI } from "api";

const fetchData = () => {
  return LibraryAPI.get({ params: { library: 5 } });
};
export const useFetchServices = () => {
  return useQuery({
    queryKey: ["services"],
    queryFn: fetchData,
  });
};
